import {ShapeCommand} from '../commands.template';
import {getActivityMinWH} from '../../diagram-render/styles/styles.util';
declare let mxUtils: any;

export class ActivityAddFooterTextCommand extends ShapeCommand {
  private readonly SFA_TOP_MARGIN = 15;
  private readonly SFA_BOTTOM_MARGIN = 20;
  private readonly FOOTER_CONTAINER_SIZE = 35 + this.SFA_TOP_MARGIN;
  services: any;
  firstAction: boolean;
  mxKey: number;
  visibleResources = 0;
  executionDelta: number;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public execute() {
    super.execute();
    const activityJson = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(this.object.mxKey);
    });

    this.visibleResources = (activityJson?.resources || []).reduce(
      (acc, curr) => (curr.hidden || curr.main ? acc : ++acc),
      0
    );
    const action = {
      changeActivity: {
        mxKey: Number(this.object.mxKey),
        footerText: 'Footer Text'
      }
    };

    this.executionDelta = this.applyGraphChanges(true);
    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.mxKey);
  }

  public reverse() {
    super.reverse();
    const action = {
      changeActivity: {
        mxKey: Number(this.object.mxKey),
        footerText: ''
      }
    };

    this.applyGraphChanges(false, this.executionDelta);
    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.mxKey);
  }

  private applyGraphChanges(add: boolean, previousDelta = null) {
    let dy = add ? this.FOOTER_CONTAINER_SIZE : -this.FOOTER_CONTAINER_SIZE;

    if (!this.visibleResources) {
      dy += add ? this.SFA_BOTTOM_MARGIN : -this.SFA_BOTTOM_MARGIN;
    }

    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = graph.model.getCell(Number(this.object.mxKey));
    const geo = cell.geometry.clone();
    const {minHeight} = getActivityMinWH(
      cell.getJson(),
      this.services.diagramTypeConfigService.currentType()
    );

    graph.getModel().beginUpdate();
    cell.skipUndo = true;
    const newMinHeight = minHeight + dy;

    graph.getModel().setStyle(cell, mxUtils.setStyle(cell.style, 'minHeight', newMinHeight));
    const deltaY = newMinHeight > geo.height ? newMinHeight - geo.height : 0;

    geo.height += previousDelta ?? deltaY;
    this.translateCellsConnectionPointsForFooter(cell, previousDelta ?? deltaY);
    graph.getModel().setGeometry(cell, geo);
    this.services.flHelper.translateConnectedEdges(
      [cell],
      {dx: 0, dy: 0},
      {dx: 0, dy: previousDelta ?? deltaY}
    );
    graph.getModel().endUpdate();

    return -deltaY;
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }

  private translateCellsConnectionPointsForFooter(cell, dy) {
    const graph = this.services.editorRegistrySvc.getGraph();
    const model = graph.getModel();

    if (cell.edges) {
      cell.edges.forEach(edge => {
        if (
          edge.source &&
          Number(edge.source.id) === Number(cell.id) &&
          isInRange(graph.getCellStyle(edge).exitY)
        ) {
          setNewY(edge, true);
        } else if (
          edge.target &&
          Number(edge.target.id) === Number(cell.id) &&
          isInRange(graph.getCellStyle(edge).entryY)
        ) {
          setNewY(edge, false);
        }
      });
    }

    function setNewY(edge, isSource) {
      const height = cell.geometry.height;
      const oldY = isSource ? graph.getCellStyle(edge).exitY : graph.getCellStyle(edge).entryY;
      let newY = oldY - (1 - height / (height + dy)) * oldY;

      if (newY < 0.01) {
        newY = 0.01;
      }

      if (newY > 0.99) {
        newY = 0.99;
      }

      if (isSource) {
        model.setStyle(edge, mxUtils.setStyle(edge.style, 'exitY', newY));
      } else {
        model.setStyle(edge, mxUtils.setStyle(edge.style, 'entryY', newY));
      }
    }

    function isInRange(num: number) {
      return num >= 0.01 && num <= 0.99;
    }
  }
}
